import { EmptyCTAButton } from '../empty';

/**
 * A call-to-action Button for users to click to resolve an error state. Optional part of the multipart `Error` component. Composes `Button`.
 */
export const ErrorCTAButton = EmptyCTAButton;
ErrorCTAButton.displayName = 'ErrorCTAButton';
